import { ReportConfig } from '../../types/ReportConfig';

export interface ReportEditPopupProps {
    reportConfig: ReportConfig;
}

export const enum ActiveTab {
    ReportType = 'report-type',
    VisibleColumns = 'visible-columns',
    Filters = 'filters',
}
